import React from 'react';
import './adminsHeader.css';
import { useDispatch } from "react-redux";
import { adminFormAction } from "../../../redux/rootReducer";
import { ADMIN_FORM_INITIAL } from "../../../redux/initialStateConstant";

const AdminsHeader = () => {
    const dispatch = useDispatch();

    return (
        <>
            <div className="button button--add"
                 onClick={ () => {
                     dispatch(adminFormAction({
                         ...ADMIN_FORM_INITIAL,
                         open: true
                     }));
                 } }
            >Добавить администратора</div>
        </>
    );
};

export default AdminsHeader;